export const getLoggedIn = state => state.session.active
